// import React, { useEffect, useState } from 'react';
// import { Button, NewTable } from '../../../../components';
// import { allBillsrowdata } from '../../../../assets/data/candidatesData';
// import { mapTableRows } from '../../../../utils';
// import Checkbox from '../../../../components/FormFields/Checkbox';

// const OpenBills = () => {
//   const tablerowData = allBillsrowdata;

//   const OpenbillsColumns = [
//       {
//       key: "InvoiceNumber",
//       label: "Invoice Number",
//       render: (row) => (
//         <span
//           className="cursor-pointer text-linkblue"
//           onClick={() => console.log(row)}
//         >{row.InvoiceNumber}
//         </span>
//       ),
//     },
//     { key: "Employees", label: "Employees" },
//     { key: "Vendor", label: "Vendor" },
//     { key: "VendorID", label: "Vendor ID" },
//     { key: "InvoiceDate", label: "Invoice Date" },
//     { key: "InvoiceDueDate", label: "Invoice Due Date" },
//     { key: "BillAmount", label: "Bill Amount" },
//     { key: "PaidAmount", label: "Paid Amount" },
//     { key: "DiscountAmount", label: "Discount Amount" },
//     { key: "DueAmount", label: "Due Amount" },
//     { key: "Createdon", label: "Created On" },
//           {
//          key: "actions",
//          label: "Actions",
//          render: (row) => (
//            <div className="flex items-center gap-2">
//              <Button
//                type="icon"
//                icon="download"
//                size="xs"
//                variant="text"
//                color="black"
//                onClick={""}
//              />
//              <Button
//                type="icon"
//                icon="edit_square"
//                size="xs"
//                variant="text"
//                color="black"
//                onClick={""}
//              />
//              <Button
//                type="icon"
//                icon="delete"
//                size="xs"
//                variant="text"
//                color="black"
//                onClick={""}

//              />
//            </div>
//          ),
//        },
//   ];

//   const mappedRows = mapTableRows(tablerowData, OpenbillsColumns);

//   return (
//     <div>
//       <NewTable

//         columns={OpenbillsColumns}
//         rows={mappedRows}
//         toolbarRight={[
//           { filterButton: false },
//           { DropdownMenu: false },
//         ]}
//       />
//     </div>
//   );
// };

// export default OpenBills;

// // import React, { useState } from 'react'
// // import { Button, Checkbox, FormFieldSet, InfoTimeCard, NewTable, PageHeader, PageTitle, Tag, useFormHandler } from '../../../../components'
// // import { useNavigate } from 'react-router-dom';
// // import { paymentrowData } from '../../../../assets/data/candidatesData';
// // import { mapTableRows } from '../../../../utils';

// // const OpenBills = () => {
// //   const navigate = useNavigate();
// //   const handleBack = () => {
// //     navigate('/accounts-payable');
// //   };
// //   const [selectedRows, setSelectedRows] = useState([]);
// //   const tablerowData = paymentrowData;
// //   const { formData, errors, handleChange, validateAllFields } = useFormHandler({
// //     Vendor: "",

// //   });

// //   const AllbillsColumns = [
// //     {
// //       key: "select",
// //       label: "",
// //       render: (row) => (
// //         <Checkbox
// //           isChecked={selectedRows.includes(row.id)}
// //           onChange={() => handleSelectRow(row.id)}
// //           size="sm"
// //         />
// //       )
// //     },
// //     { key: "Description", label: "Description" },
// //     { key: "DueDate", label: "Due Date" },
// //     { key: "OriginalAmount", label: " Original Amount" },
// //     { key: "PaymentReceived", label: " Payment Received" },
// //     { key: "OpenBalance", label: "Open Balance" },
// //     { key: "EnterPaymentAmount", label: "Enter Payment Amount" },
// //     { key: "PaymentDiscount", label: " Payment Discount" },
// //     { key: "Actions", label: "Actions" },
// //   ];
// //   const mappedRows = mapTableRows(tablerowData, AllbillsColumns);

// //   return (
// //     <div>
// //       <div>
// //         <PageHeader
// //           Section={
// //             <div className="flex gap-3">
// //               <PageTitle title={"Create Vendor Payment"} tag="h5" size={"sm"} />
// //               <Tag
// //                 title="Tektree"
// //                 variant="outlined"
// //                 className=" !text-neutrals !py-1.5"
// //               />
// //             </div>
// //           }
// //           RightSection={
// //             <div className="flex gap-3">
// //               <Button
// //                 size="sm"
// //                 title={"Back"}
// //                 icon={"arrow_left_alt"}
// //                 onClick={handleBack}
// //               />

// //             </div>
// //           }
// //         />
// //       </div>
// //       <div className="grid grid-cols-4 max-w-9xl gap-x-10 gap-y-6 mt-4">
// //         <FormFieldSet
// //           type="select"
// //           title="Vendor"
// //           placeholder=" select Vendor"
// //           value={formData.Vendor}
// //           onChange={(value) => handleChange("Vendor", value)}
// //           error={errors.Vendor}
// //         />
// //         <div className='mt-5'>
// //           <Button
// //             title={"View Bank Details"}
// //             onClick={handleBack}
// //           />
// //         </div>
// //         <div></div>
// //         <div className='mr-10 mt-5'>
// //           <InfoTimeCard
// //             title="Paid Amount"
// //             color="primary"
// //             value={"147833.72"}
// //             suffix={"USD"}
// //             type2
// //           />
// //         </div>
// //         <FormFieldSet
// //           type="select"
// //           title="Payment Date"
// //           placeholder=" select Payment Date"
// //           value={formData.PaymentDate}
// //           onChange={(value) => handleChange("PaymentDate", value)}
// //           error={errors.PaymentDate}
// //         />
// //         <FormFieldSet
// //           type="select"
// //           title="Payment Type"
// //           placeholder=" select Payment Type"
// //           value={formData.PaymentType}
// //           onChange={(value) => handleChange("PaymentType", value)}
// //           error={errors.PaymentType}
// //         />
// //         <FormFieldSet
// //           type="select"
// //           title="Account Type"
// //           placeholder=" select AccountType"
// //           value={formData.AccountType}
// //           onChange={(value) => handleChange("AccountType", value)}
// //           error={errors.AccountType}
// //         />
// //         <div></div>
// //         <FormFieldSet
// //           type="select"
// //           title="Reference Number"
// //           placeholder=" select Reference Number"
// //           value={formData.ReferenceNumber}
// //           onChange={(value) => handleChange("ReferenceNumber", value)}
// //           error={errors.ReferenceNumber}
// //         />
// //         <FormFieldSet
// //           type="textArea"
// //           title="Notes"
// //           placeholder=" select Notes"
// //           value={formData.Notes}
// //           onChange={(value) => handleChange("Notes", value)}
// //           error={errors.Notes}
// //         />
// //         <div></div>
// //         <FormFieldSet
// //           type="select"
// //           title=" Paid Amount"
// //           placeholder=" select  Paid Amount"
// //           value={formData.PaidAmount}
// //           onChange={(value) => handleChange("PaidAmount", value)}
// //           error={errors.PaidAmount}
// //         />
// //       </div>
// //       <div className="flex justify-end">
// //         <Button
// //           size="md"
// //           title={"Clear Payament"}
// //           onClick={handleBack}
// //         />
// //       </div>
// //       <div>
// //         <NewTable
// //           columns={AllbillsColumns}
// //           rows={mappedRows}
// //           toolbarRight={[
// //             { filterButton: false },
// //             { DropdownMenu: false },
// //           ]}
// //         />
// //       </div>
// //       <div className="flex items-center justify-between mt-5">
// //         <p> Invoice Details</p>
// //         <Button
// //           size="sm"
// //           title={"Add"}
// //           onClick={""}
// //           color='black'
// //           icon={"add"}
// //         />
// //       </div>
// //       <hr className="border-t border-gray-300" />
// //         <div className="flex gap-3 justify-end my-6">
// //           <Button title="Cancel" variant="outlined" onClick={""} />
// //           <Button title="Save" onClick={""} />
// //         </div>
// //     </div>
// //   )
// // }

// // export default OpenBills

import React, { useEffect, useState } from "react";
import { NewTable, Button, Backdrop, LogoLoader, Modal } from "../../../../components";
import { useSelector, useDispatch } from "react-redux";
import { getAccountPayablesStart } from "../../../../redux/slices/accountPayables/accountPayablesSlice";
import { totalCountStart } from "../../../../redux/slices/totalCount/totalCountSlice";
import { dateFormator, mapTableRows } from "../../../../utils";
import { usePagination } from "../../../../hooks";
import { getVendorId } from "../../../../utils/getClientId";
import { Link, useNavigate } from "react-router-dom";
import { formatCurrency } from "../../../../utils/stringUtils";
import ApInvoiceDetails from "../Modals/ApInvoiceDetails";

const OpenBills = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "uiid",
    direction: -1,
  });

  const { loading, error, accountPayables } = useSelector(
    (state) => state.accountPayables,
  );
  const { value } = useSelector((state) => state.totalCount);

  const totalCount = value?.accountpayables?.data;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(getAccountPayablesStart({ page: newPage, limit: newLimit }));
    },
  );

  const tablerowData = accountPayables?.data || [];

  const handleSort = (field) => {
    setSortConfig((prev) => ({
      field,
      direction: prev.field === field ? -prev.direction : -1,
    }));
  };

  const OpenbillsColumns = [
    {
      key: "invoiceNum",
      label: "Invoice Number",
      render: (row) => (
        <div className="flex items-center gap-1">
          {/* <Link
            to={`/accounts-payable/edit/${row.uiid}`}
            state={{ code: row.uiid, edit: true }}
          > */}
          <span
            className="text-linkblue"
            onClick={() => setSelectedInvoice(row?.uiid)}
          >
            {row.invoiceNum}
          </span>
          {/* </Link> */}
        </div>
      ),
    },
    {
      key: "employeeId",
      label: "Employees",
      render: (row) =>
        row.employeeId.map((emp, i) => (
          <span key={i}>
            {[emp.firstName, emp.lastName].filter(Boolean).join(" ")}
            {i < row.employeeId.length - 1 && ", "}
          </span>
        )),
    },
    {
      key: "vendorId",
      label: "Vendor",
      render: (row) => row.vendorId.businessName || "-",
    },
    {
      key: "VendorID",
      label: "Vendor ID",
      render: (row) => getVendorId(row.vendorId.uiid),
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
      render: (row) => dateFormator(row.invoiceDate, "month-day-year"),
    },
    {
      key: "dueDate",
      label: "Invoice Due Date",
      render: (row) => dateFormator(row.dueDate, "month-day-year"),
    },
    {
      key: "billedAmount",
      label: "Bill Amount",
      render: (row) => formatCurrency(row.amounts.billed),
    },
    {
      key: "paidAmount",
      label: "Paid Amount",
      render: (row) => formatCurrency(row.amounts.paid),
    },
    {
      key: "discountAmount",
      label: "Discount Amount",
      render: (row) => formatCurrency(row.amounts.discount),
    },
    {
      key: "dueAmount",
      label: "Due Amount",
      render: (row) => formatCurrency(row.amounts.due),
    },
    {
      key: "addedOn",
      label: "Created On",
      render: (row) => dateFormator(row.addedOn, "month-day-year"),
    },
    {
      key: "actions",
      label: "Actions",
      render: (row) => (
        <div className="flex items-center gap-2">
          <Button
            type="icon"
            icon="download"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
          <Button
            type="icon"
            icon="edit_square"
            size="xs"
            variant="text"
            color="black"
            onClick={() => navigate(`/accounts-payable/edit/${row.uiid}`)}
          />
          <Button
            type="icon"
            icon="delete"
            size="xs"
            variant="text"
            color="black"
            onClick={""}
          />
        </div>
      ),
    },
  ];

  const mappedRows = mapTableRows(tablerowData, OpenbillsColumns);

  useEffect(() => {
    dispatch(
      getAccountPayablesStart({
        limit,
        page,
        ref: "Employee Vendor",
        filters: {
          dueDate: {
            type: "GTE",
            value: new Date(),
          },
        },
        incl: ["firstName lastName", "businessName"],
        sort: { [sortConfig.field]: sortConfig.direction },
      }),
    );
    dispatch(
      totalCountStart({
        collection: "accountpayables",
        coll: "AccountPayable",
        filters: {
          dueDate: {
            type: "GT",
            value: new Date(),
          },
        },
      }),
    );
  }, [dispatch, page, limit, sortConfig]);

  return (
    <div>
      <Backdrop isOpen={loading}>
        <LogoLoader />
      </Backdrop>
      <NewTable
        showCheckbox
        columns={OpenbillsColumns}
        rows={mappedRows}
        serverPagination
        totalCount={totalCount}
        page={page}
        limit={limit}
        onPageChange={setPage}
        onLimitChange={handleLimitChange}
        toolbarRight={[{ filterButton: false }, { DropdownMenu: false }]}
      />
      <Modal
        isOpen={selectedInvoice}
        title={"AP Invoice Details"}
        onClose={() => setSelectedInvoice(null)}
        showCloseButton={true}
        closeOnOutsideClick={true}
        width="max-w-full"
        zIndex={56}
      >
        <ApInvoiceDetails
          invoiceUiid={selectedInvoice}
          onBack={() => setSelectedInvoice(null)}
          removeButtonForPreview={false}
        />
      </Modal>
    </div>
  );
};

export default OpenBills;
